import React, { memo } from "react";
import ProductManagementTable from "../Components/ProductManagement/ProductManagementTable";

function ProductManagementPage() {
  return (
    <>
      <ProductManagementTable />
    </>
  );
}

export default memo(ProductManagementPage);
